export enum EMoyenObservation {
    EnZoneDeTravail,
    BulleDeVision,
    Camera,
    ExterieurDansLePerimetreDeChantier
}